import Wrapper from './wrapper';
import {
  IExtractionBatchUpdateParams,
  IWrapper,
  IExtractionBatchCreateParams,
  IExtractionBatchListParams,
  IExtractionBatchListResponse,
  IReportParams,
  ITransformParams,
  ITransformJsonResponse,
  TransformParamsCsv,
  TransformParamsJson,
} from './types';
import { IExtractionBatch } from '../types/my-types';

class ExtractionBatch {
  wrapper: IWrapper;
  /**
   * @param {Wrapper} wrapper
   */
  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  create(data: IExtractionBatchCreateParams) {
    return this.wrapper.client.post<IExtractionBatch, IExtractionBatch>(
      `data-pools/${this.wrapper.dataPoolId}/extraction-batches/?advanced=true`,
      data
    );
  }

  list(params: IExtractionBatchListParams) {
    return this.wrapper.client.get<IExtractionBatchListResponse, IExtractionBatchListResponse>(
      `data-pools/${this.wrapper.dataPoolId}/extraction-batches/`,
      { params }
    );
  }

  retrieve(id: string) {
    return this.wrapper.client.get<IExtractionBatch, IExtractionBatch>(
      `data-pools/${this.wrapper.dataPoolId}/extraction-batches/${id}/?advanced=true`
    );
  }

  update(id: string, data: IExtractionBatchUpdateParams) {
    return this.wrapper.client.patch<IExtractionBatch, IExtractionBatch>(
      `data-pools/${this.wrapper.dataPoolId}/extraction-batches/${id}/?advanced=true`,
      data
    );
  }

  del(id: string) {
    return this.wrapper.client.delete(
      `data-pools/${this.wrapper.dataPoolId}/extraction-batches/${id}/?advanced=true`
    );
  }

  distribution(id: string, params: IReportParams) {
    return this.wrapper.client.get(
      `data-pools/${this.wrapper.dataPoolId}/extraction-batches/${id}/field-distribution/`,
      {
        params,
      }
    );
  }

  transformer(id: string, params: TransformParamsCsv): Promise<string>;
  transformer(id: string, params: TransformParamsJson): Promise<ITransformJsonResponse>;
  transformer(id: string, params: ITransformParams) {
    const accept = params.format === 'csv' ? 'text/csv' : 'application/json';
    const url = `data-pools/${this.wrapper.dataPoolId}/extraction-batches/${id}/transformed-results/`;
    if (params.format === 'csv') {
      return this.wrapper.client.get<string, string>(url, { params, headers: { accept } });
    }
    return this.wrapper.client.get<ITransformJsonResponse, ITransformJsonResponse>(url, {
      params,
      headers: { accept },
    });
  }

  refreshTransformed(id: string) {
    return this.wrapper.client.post(
      `data-pools/${this.wrapper.dataPoolId}/extraction-batches/${id}/refresh-transformed/`
    );
  }

  generatePages(id: string) {
    return this.wrapper.client.post(
      `data-pools/${this.wrapper.dataPoolId}/extraction-batches/${id}/pages/?advanced=true`
    );
  }

  clean(id: string) {
    return this.wrapper.client.post(
      `data-pools/${this.wrapper.dataPoolId}/extraction-batches/${id}/clean/?advanced=true`
    );
  }
}

export default ExtractionBatch;
